import { Component, computed, input, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IStaticStylesConfig } from '../../../skins/_primitives/IStaticStylesConfig';
import { MatwinsSkins } from '../../../skins/global.skin';


@Component({
  selector: 'app-button-paginator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button-paginator.component.html'
})
export class ButtonPaginatorComponent {
  page = model.required<number>();
  pageSize = model.required<number>();
  total = input.required<number>();
  totalItems = input.required<number>();

  Skin = input<IStaticStylesConfig>(MatwinsSkins.V1);

  activeButtonClass = computed(() => {
    return `${this.Skin().btnPrimary} px-3 h-8 text-sm border`;
  });

  inactiveButtonClass = computed(() => {
    return `px-3 h-8 hover:bg-gray-100 text-sm border text-gray-600`;
  });

  // NOTE v22 : pas d'output explicite pageChange/pageSizeChange ici —
  // model() expose déjà ces outputs implicites (NG1054 sinon)

  totalPages = computed(() => Math.ceil(this.total() / this.pageSize()));

  onPageChange(newPage: number): void {
    if (newPage > 0 && newPage <= this.totalPages()) {
      this.page.set(newPage);
    }
  }

  onPageSizeChange(newPageSize: number): void {
    this.pageSize.set(newPageSize);
  }

  getVisiblePages(): number[] {
    const current = this.page();
    const last = this.totalPages();
    const delta = 2;
    const left = current - delta;
    const right = current + delta + 1;
    const range = [];
    const pages = [];

    for (let i = 1; i <= last; i++) {
      if (i === 1 || i === last || (i >= left && i < right)) {
        range.push(i);
      }
    }

    let l;
    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          pages.push(l + 1);
        } else if (i - l !== 1) {
          pages.push(-1);
        }
      }
      pages.push(i);
      l = i;
    }

    return pages;
  }
}

